let gCurrentId = 0;

export default class IdManager
{
	static getNewId()
	{
		gCurrentId++;
		return gCurrentId;
	}

	static resetIdCount()
	{
		gCurrentId = 0;
	}

	static getLoadingMaxId()
	{
		return gCurrentId;
	}

	static setLoadedMaxId(iMaxId)
	{
		// TODO: Figure out if this something we want to flag or ignore
		/*
		if(iMaxId < gCurrentId)
		{
			// console.warn(`Setting max load id that is SMALLER than the existing id - current is ${gCurrentId}, new is ${iMaxId}.`);
			// return;
		}
		*/
		gCurrentId = iMaxId;
	}
};